import Axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export class HttpService {
  constructor() {
    this._axios = Axios.create({
      baseURL: API_URL,
      withCredentials: true,
    });

    // Attach auth token automatically
    this._axios.interceptors.request.use(
      (config) => {
        let token = localStorage.getItem("authToken");
        if (token) {
          token = token.replace(/^"|"$/g, "");
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );
  }

  // === Reintroduced wrappers for backward compatibility ===
  addRequestInterceptor = (onFulfilled, onRejected) => {
    return this._axios.interceptors.request.use(onFulfilled, onRejected);
  };

  addResponseInterceptor = (onFulfilled, onRejected) => {
    return this._axios.interceptors.response.use(onFulfilled, onRejected);
  };

  // Optional: remove an interceptor by id returned from add* methods
  ejectRequestInterceptor = (id) => {
    this._axios.interceptors.request.eject(id);
  };

  ejectResponseInterceptor = (id) => {
    this._axios.interceptors.response.eject(id);
  };
  // =========================================================

  async request(options) {
    try {
      const response = await this._axios.request({
        ...options,
        withCredentials: true,
      });
      console.log("Response:", response.data);
      return response.data;
    } catch (ex) {
      console.error("HTTP Service Error:", ex.message);
      const status = ex?.response?.status;
      const errorMessage =
        ex?.response?.data?.message || "An unknown error occurred.";
      console.log("Error Details:", {
        status,
        message: errorMessage,
        data: ex?.response?.data,
      });
      throw { status, message: errorMessage };
    }
  }

  getOptionsConfig(method, url, data = null, params = null, config = {}) {
    const headers = { ...(config.headers || {}) };
    if (data instanceof FormData) {
      delete headers["Content-Type"];
    }
    return {
      method,
      url,
      ...(method !== "delete" && { data }),
      params,
      headers,
      ...config,
    };
  }

  get = (url, params) =>
    this.request(this.getOptionsConfig("get", url, null, params));

  post = (url, data, config = {}) =>
    this.request(this.getOptionsConfig("post", url, data, null, config));

  put = (url, data) => this.request(this.getOptionsConfig("put", url, data));

  patch = (url, data) =>
    this.request(this.getOptionsConfig("patch", url, data));

  delete = (url) =>
    this.request({
      method: "delete",
      url,
      headers: { "Content-Type": "application/json" },
    });
}

export default new HttpService();
